import { PaymentInstrument } from "@api/graphql/generated/generated-types";

export const formatPaymentMethod = (instrument: PaymentInstrument, isShortForm: boolean = false): string => {
  const { creditCardDetail, bankAccountDetail } = instrument;

  if (creditCardDetail) {
    const { name, brand, lastFour } = creditCardDetail;
    if (isShortForm) {
      return `${name} ••• ${lastFour}`;
    }
    return `${name} • ${brand} •••• ${lastFour}`;
  }

  if (bankAccountDetail) {
    const { name, maskedAccountNumber, institutionNumber, transitNumber } = bankAccountDetail;
    if (
      instrument.paymentInstrumentType === "CANADIAN_BANK_ACCOUNT" &&
      institutionNumber &&
      transitNumber
    ) {
      return `${name} • ${institutionNumber}-${transitNumber} •••• ${maskedAccountNumber.slice(-4)}`;
    }
    return `${name} • ${maskedAccountNumber}`;
  }

  return "-";
};

export const formatPaymentMethodSubtitle = (
  instrument: PaymentInstrument
): string => {
  if (instrument.paymentInstrumentType === "CREDIT_CARD")
    return `Expires ${instrument.creditCardDetail?.expirationMonth}/${instrument.creditCardDetail?.expirationYear}`;

  if (instrument.paymentInstrumentType === "CANADIAN_BANK_ACCOUNT") {
    const institutionNumber = instrument.bankAccountDetail?.institutionNumber;
    const transitNumber = instrument.bankAccountDetail?.transitNumber;

    if (institutionNumber && transitNumber)
      return `Institution: ${institutionNumber} Transit: ${transitNumber}`;

    return "";
  }

  return `Bank Code: ${instrument.bankAccountDetail?.bankCode}`;
};
